import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-09-14T18:58:24+0530.
 */
export function useInspectionsCustomNameEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionsCustomName,
    false
  );

  return Boolean(isEnabled);
}
